import { isDragActive as m } from "./atoms-v21112.js";
import { setupGesture as E } from "./atoms-v21113.js";
function c(n) {
  return (e) => {
    e.pointerType === "touch" || m() || n(e);
  };
}
function L(n, e, p = {}) {
  const [f, o, u] = E(n, p), v = c((t) => {
    const { target: r } = t, i = e(t);
    if (typeof i != "function" || !r)
      return;
    const s = c((a) => {
      i(a), r.removeEventListener("pointerleave", s);
    });
    r.addEventListener("pointerleave", s, o);
  });
  return f.forEach((t) => {
    t.addEventListener("pointerenter", v, o);
  }), u;
}
export {
  L as hover
};
